import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { DeepLink } from '../../types/DeepLink';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { useStyles } from './customCard.style';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@material-ui/core';

interface CustomCardProps {
  title: string;
  subheader?: string;
  children: ReactNode;
  deepLink?: DeepLink;
  tooltip?: string;
  extraInfo?: string;
}

function CustomHealthCard({
  title,
  subheader,
  children,
  deepLink,
  tooltip = '',
  extraInfo = '',
}: Readonly<CustomCardProps>) {
  const { cx, classes } = useStyles();

  return (
    <Card className={cx(classes.card)}>
      <CardHeader
        title={title}
        titleTypographyProps={{ align: 'center', variant: 'h6' }}
        subheader={subheader}
        subheaderTypographyProps={{ align: 'center' }}
        action={
          tooltip !== '' ? (
            <Tooltip
              title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>}
              arrow
            >
              <InfoOutlinedIcon className={cx(classes.tooltip)} />
            </Tooltip>
          ) : (
            extraInfo !== '' && (
              <Typography variant="body2" className={cx(classes.extraInfo)}>
                {extraInfo}
              </Typography>
            )
          )
        }
      />
      <Box my={1}>
        <Divider />
      </Box>
      <CardContent className={cx(classes.content)}>
        <Box display="flex" flexDirection="column">
          {children}
        </Box>
      </CardContent>
      {deepLink && (
        <CardActions>
          <Box marginTop={2}>
            <RouterLink
              to={deepLink.link}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              {deepLink.title}
              <ArrowForwardIcon fontSize="small" />
            </RouterLink>
          </Box>
        </CardActions>
      )}
    </Card>
  );
}

export { CustomHealthCard };
